import { FaChevronRight } from "react-icons/fa";
import { useTranslation } from "react-i18next";

export interface BreadcrumbItem {
  name: string;
  id: string;
}

interface BreadcrumbProps {
  breadcrumb: BreadcrumbItem[];
  onPathClick?: (id: string, index: number) => void;
  baseLabel?: string;
}

const Breadcrumb = ({
  breadcrumb = [],
  onPathClick,
  baseLabel = "Library",
}: BreadcrumbProps) => {
  const { t } = useTranslation();
  return (
    <div className="mb-4 mt-12 flex items-center gap-3 text-base sm:mt-0">
      <button
        onClick={() => onPathClick?.("/", -1)}
        className="text-lg text-gray-600 hover:text-navy-700 dark:text-gray-300 dark:hover:text-white"
      >
        {baseLabel === "Library" ? t("routes.library") : baseLabel}
      </button>
      {breadcrumb.map((item, index) => (
        <div key={item.id} className="flex items-center gap-3">
          <FaChevronRight className="text-sm text-gray-400" />
          {index === breadcrumb.length - 1 ? (
            <span className="text-lg font-bold text-navy-700 dark:text-white">
              {item.name}
            </span>
          ) : (
            <button
              onClick={() => onPathClick?.(item.id, index)}
              className="text-lg text-gray-600 hover:text-navy-700 dark:text-gray-300 dark:hover:text-white"
            >
              {item.name}
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default Breadcrumb;
